import React from 'react';
interface DateFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
}
export function DateField({
  label,
  value,
  onChange,
  required = false
}: DateFieldProps) {
  return <div className="flex flex-col gap-1" data-id="element-105">
      <label className="text-sm font-medium text-gray-700" data-id="element-106">
        {label}
        {required && <span className="text-red-500 ml-1" data-id="element-107">*</span>}
      </label>
      <input type="date" value={value} onChange={e => onChange(e.target.value)} required={required} className="px-3 py-1.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent" data-id="element-108" />
    </div>;
}